import { Component } from '@angular/core';

@Component({
  selector: 'vtab-panel-title',
  templateUrl: './vtab-panel-title.component.html',
  styleUrls: ['./vtab-panel-title.component.scss'],
  standalone: false,
})
export class VTabPanelTitleComponent { }
